<template>
    <div class="location-back">
        <!--环图片-->
        <div class="img-box">
            <div class="prop-up"></div>
            <img src="@/assets/img/circle.png" class="circle" alt="">
        </div>
        <!--题目-->
        <div class="subject">
            <div>{{ $t('gardenTitle') }}</div>
        </div>
        <!--选项-->
        <div style="width:130px;margin:calc(0.073 * var(--body-height)) auto 0;">
            <el-radio-group v-model="status">
                <el-radio :label="$t('status1')"></el-radio>
                <el-radio :label="$t('status2')"></el-radio>
                <el-radio :label="$t('status3')"></el-radio>
            </el-radio-group>
        </div>
        <!--题目跳转-->
        <div class="subject-jump">
            <span @click="prevClick" class="prev-btn">{{ $t('preQues') }}</span>
            <el-button @click="nextClick" :disabled="countNumber != 0" style="width:160px;"
                type="primary">{{ $t('nextQues') }} <i class="icon-right"></i> ({{ countNumber }}s)
            </el-button>
        </div>
    </div>

</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "garden",
    data() {
        return {
            //状态
            status: '',
            timer: null,
            countNumber: 0
        }
    },
    computed: {
        ...mapGetters([
            'gardenAnswer'
        ]),
    },
    watch: {
        '$route': {
            immediate: true, // 组件创建时立即触发
            handler(newVal, oldVal) {
                this.$store.commit('SET_ANSWER_PERCENT', 12 * 100 / 22)
            }
        }
    },
    mounted() {
        this.countdown()
        this.status = this.gardenAnswer
    },
    methods: {

        /**
         * 上一题
         */
        prevClick() {
            this.$router.push('/location3')
        },

        /**
         * 下一题
         */
        nextClick() {
            if (this.status == '') {
                this.$toast(this.$t('selectOne'));
                return;
            }
            //保存答案
            this.$store.commit('SET_GARDEN_ANSWER', this.status)
            // 页面跳转
            if (this.status === this.$t('status1')) {
                this.$store.commit('SET_LEAVE1_ANSWER', '')
                this.$router.push('/enter1')
            } else if (this.status === this.$t('status2')) {
                this.$store.commit('CLEAR_ENTER')
                this.$router.push('/leave1')
            } else {
                //清空其他分支答案
                this.$store.commit('CLEAR_ENTER')
                this.$store.commit('SET_LEAVE1_ANSWER', '')
                this.$router.push('/location4')
            }
        },

        /**
         * 验证码倒计时
         */
        countdown() {
            let that = this;
            this.countNumber = 2;
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(function () {
                if (that.countNumber === 0) {
                    clearInterval(this.timer);
                } else {
                    that.countNumber--;
                }
            }, 1000);
        }
    }
}
</script>

<style scoped lang="less">
.location-back {
    height: 100%;
}
</style>